<div id="header" class="header">
    <div class="header-top">
        <div class="content-container-top ">
            <div class="pure-g">
                <div class="pure-u-md-12-24 pure-u-sm-12-24 pure-u-1">
                    This site is intended for US Residents.
                </div>
                <div class="pure-u-md-12-24 pure-u-sm-12-24 pure-u-1 healthcareanchor">
                    <a routerLink="/hcp" target="_blank">To healthcare professional site<img src="../../../assets/img/arrow_icon.png" title="To healthcare professional site arrow" alt="To healthcare professional site arrow"/></a>
                </div>
            </div>
        </div>
     </div>
    
</div>
<section id="sec_header" class="sec_header" [hidden] ="this.signuphide">
    <div class="top_header pure-g"><p><a href="#sign-up">Sign up for updates about Factor XIIa</a></p><img src="../../../assets/img/top_down_arrow.svg" title="Sign up for updates about Factor XIIa down arrow" alt="Sign up for updates about Factor XIIa down arrow"/></div>
</section>